import React, { useEffect, useState, Fragment } from "react";
import axios from "axios";
import { Form } from "react-bootstrap";
import config from '../../../config';

export default function SchoolTimetable() {
  const [academicYear, setAcademicYear] = useState("2026-2027");
  const [data, setData] = useState([]);
  const [periods, setPeriods] = useState([]);
  const [loading, setLoading] = useState(false);
  const [teacherLoad, setTeacherLoad] = useState([]);

  const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];

  /* ---------------------------------------
     Fetch School Timetable
  --------------------------------------- */
  const fetchTimetable = async () => {
    try {
      setLoading(true);

      const res = await axios.get(
        `${config.apiBaseUrl}/academic/get-school-timetable.php`,
        { params: { academic_year: academicYear } }
      );

      if (res.data.success) {
        setData(res.data.data);
        setTeacherLoad(res.data.teacher_load || []);
      }

    } catch (err) {
      console.error("Failed to load timetable");
    } finally {
      setLoading(false);
    }
  };

  /* ---------------------------------------
     Fetch Periods
  --------------------------------------- */
  const fetchPeriods = async () => {
    try {
      const res = await axios.get(
        `${config.apiBaseUrl}/academic/get-periods.php`,
        { params: { academic_year: academicYear } }
      );

      if (res.data.success) {
        setPeriods(res.data.data);
      }
    } catch (err) {
      console.error("Failed to load periods");
    }
  };

  useEffect(() => {
    fetchTimetable();
    fetchPeriods();
  }, [academicYear]);

  /* ---------------------------------------
     Group Data
  --------------------------------------- */
  const grouped = {};

  data.forEach((row) => {
    if (!grouped[row.day_of_week]) {
      grouped[row.day_of_week] = {};
    }

    if (!grouped[row.day_of_week][row.period_number]) {
      grouped[row.day_of_week][row.period_number] = [];
    }

    grouped[row.day_of_week][row.period_number].push(row);
  });

  return (
    <Fragment>
      <div className="row">
        <div className="col-xl-12">

          <div className="page-title">
            <h4>School Timetable (All Classes)</h4>
          </div>
          
          {/* Teacher Load Summary */}
            <div className="mb-4">
            <h5>Teacher Weekly Load</h5>
            <div className="table-responsive">
                <table className="table table-bordered table-sm">
                <thead>
                    <tr>
                    <th>Teacher</th>
                    <th>Total Periods (Week)</th>
                    </tr>
                </thead>
                <tbody>
                    {teacherLoad.length > 0 ? (
                    teacherLoad.map((teacher, index) => (
                        <tr key={index}>
                        <td>{teacher.fullname}</td>
                        <td>{teacher.total_periods}</td>
                        </tr>
                    ))
                    ) : (
                    <tr>
                        <td colSpan="2" className="text-center text-muted">
                        No Data Available
                        </td>
                    </tr>
                    )}
                </tbody>
                </table>
            </div>
            </div>

          {loading && <p>Loading...</p>}

          {days.map((day) => (
            <div key={day} className="mb-4">

              <h5 className="mb-3">{day}</h5>

              {periods.map((period) => {
                const periodData =
                  grouped[day]?.[period.period_number] || [];

                if (period.is_break === "Yes") {
                  return (
                    <div key={period.period_number} className="mb-3 p-2 bg-light">
                      <strong>
                        {period.period_name} (
                        {period.start_time.slice(0,5)} -{" "}
                        {period.end_time.slice(0,5)})
                      </strong>
                      <div>Break</div>
                    </div>
                  );
                }

                return (
                  <div key={period.period_number} className="mb-3">

                    <div className="fw-bold mb-2">
                      {period.period_name} (
                      {period.start_time.slice(0,5)} -{" "}
                      {period.end_time.slice(0,5)})
                    </div>

                    <div className="table-responsive">
                      <table className="table table-bordered table-sm">
                        <thead>
                          <tr>
                            <th>Class</th>
                            <th>Subject</th>
                            <th>Teacher</th>
                          </tr>
                        </thead>
                        <tbody>
                          {periodData.length > 0 ? (
                            periodData.map((row, index) => (
                              <tr key={index}>
                                <td>
                                  {row.class_name} - {row.section}
                                </td>
                                <td>{row.subject_name}</td>
                                <td>{row.teacher_name}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="3" className="text-center text-muted">
                                No Classes Scheduled
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                  </div>
                );
              })}
            </div>
          ))}

        </div>
      </div>
    </Fragment>
  );
}